module.exports = __webpack_public_path__ + "static/media/jeans.0bbd31c9.svg";